import { useCallback, useEffect, useId, useRef, useState } from "react";
import { isWeb, useComposedRefs } from "@tamagui/core";
const useInputId = (id) => {
  const backupId = useId();
  return id || backupId;
}, useInputName = (name) => {
  const ref = useRef(null);
  return useEffect(() => {
    isWeb && name && ref.current instanceof HTMLElement && ref.current?.setAttribute("name", name);
  }, [name]), ref;
}, useFrameFocus = (ref) => {
  const focusRef = useRef(null);
  return { inputRef: useComposedRefs(ref, focusRef), handleFramePress: () => {
    focusRef.current?.focus();
  } };
}, useInputState = ({
  disabled,
  errorText,
  invalid,
  onFocus,
  onBlur
}) => {
  const [focused, setFocused] = useState(!1), handleFocus = useCallback(
    (e) => {
      setFocused(!0), onFocus && onFocus(e);
    },
    [onFocus]
  ), handleBlur = useCallback(
    (e) => {
      setFocused(!1), onBlur && onBlur(e);
    },
    [onBlur]
  );
  return { state: disabled ? "inactive" : errorText || invalid ? "error" : focused ? "focused" : void 0, handleFocus, handleBlur, setFocused };
};
export {
  useFrameFocus,
  useInputId,
  useInputName,
  useInputState
};
